import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { favoritesPropTypes, queuePropType, readerRefPropType } from 'utils/prop-types';
import { getTrackPageRoute } from 'utils/routes';
import ASSET from 'constants/asset-types';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import DropdownMenu from 'components/common/dropdown-menu';
import { InfoIcon } from 'components/icons';

const MoreMenuButton = memo((props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    queue,
    activeIndex,
    className,
    readerRef,
    placement,
    textClassName,
    itemClassName,
    controlBtnProps,
    dividerClassName,
    changeFullAudioPlayerViewAction,
    changeFullVideoPlayerViewAction,
    changeEbookReaderOpenAction,
  } = props;

  const { trackId, contentType } = queue?.[activeIndex] ?? {};

  const handleMoreInfoClick = useCallback(() => {
    switch (contentType) {
      case ASSET.contentType.audio:
        changeFullAudioPlayerViewAction(false);
        break;
      case ASSET.contentType.video:
        changeFullVideoPlayerViewAction(false);
        break;
      case ASSET.contentType.ebook:
        changeEbookReaderOpenAction(false);
        break;
      default:
        break;
    }

    history.push(getTrackPageRoute(trackId));
  }, [trackId, contentType]);

  return (
    <DropdownMenu
      placement={placement}
      dividerClassName={dividerClassName}
      controlBtnProps={controlBtnProps}
      popperClassName={className}
      readerRef={readerRef}
      icon={MoreIcon}
      items={[
        {
          className: itemClassName,
          labelClassName: textClassName,
          label: t`generic_button_details`,
          onClick: handleMoreInfoClick,
          closeMenuAfterAction: true,
          icon: InfoIcon,
          iconProps: {
            className: textClassName,
          },
        },
      ]}
    />
  );
});

MoreMenuButton.propTypes = {
  queue: queuePropType,
  placement: PropTypes.string,
  favorites: favoritesPropTypes,
  activeIndex: PropTypes.number.isRequired,
  className: PropTypes.string,
  textClassName: PropTypes.string,
  itemClassName: PropTypes.string,
  dividerClassName: PropTypes.string,
  readerRef: readerRefPropType,
  controlBtnProps: PropTypes.shape({
    className: PropTypes.string,
    iconClassName: PropTypes.string,
  }),
  changeFullAudioPlayerViewAction: PropTypes.func.isRequired,
  changeFullVideoPlayerViewAction: PropTypes.func.isRequired,
  changeEbookReaderOpenAction: PropTypes.func.isRequired,
};

MoreMenuButton.defaultProps = {
  className: '',
  textClassName: '',
};

export default MoreMenuButton;
